module.exports = __webpack_public_path__ + "img/mayra1.a9a59175.jpg";